import { multipartForm } from './Client';

const uploadMeso = (id, file) =>
  multipartForm(`/participacoes/${id}/upload/meso`, { body: file });

const uploadMicro = (id, file) =>
  multipartForm(`/participacoes/${id}/upload/micro`, { body: file });

const uploadMunicipio = (id, file) =>
  multipartForm(`/participacoes/${id}/upload/municipio`, { body: file });

const uploadGeral = (id, file) =>
  multipartForm(`/participacoes/${id}/upload/geral`, { body: file });

export { uploadMeso, uploadMicro, uploadMunicipio, uploadGeral };



// WEBPACK FOOTER //
// ./src/utils/ParticipacaoAPI.js